module.exports = __webpack_public_path__ + "img/header.127c9188.png";